import React, { useState, useRef } from 'react';
import KakaoMap from '../KakaoMap/KakaoMap';
import KakaoMap2 from '../KakaoMap/KaKaoMap2';
import KakaoMap3 from '../KakaoMap/KaKaoMap3';
import { useNavigate, useLocation } from 'react-router-dom';

const Map = () => {
  const [select, setSelect] = useState(0);
  const [activeCenter, setActiveCenter] = useState('dangjin');

  const navigate = useNavigate();
  const location = useLocation();

  // 각 센터 섹션 ref
  const dangjinRef = useRef(null);
  const asanRef = useRef(null);
  const hongRef = useRef(null);

  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate: cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // 센터 섹션으로 스크롤 (당진 / 아산 / 홍성)
  const scrollToSection = (target) => {
    const refs = {
      dangjin: dangjinRef,
      asan: asanRef,
      hong: hongRef,
    };

    const ref = refs[target];

    if (ref && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

    // 서브메뉴 active 표시
    setActiveCenter(target);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area intro-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}융합원 소개{' > '}오시는 길
            </div>
            <div className="banner_main_text">오시는 길</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">융합원소개</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">오시는 길</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/intro')}>
                  인사말
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  비전 및 목표
                </div>
                <div className="select_row" onClick={() => movePage('/history')}>
                  연혁
                </div>
                <div className="select_row" onClick={() => movePage('/organization')}>
                  조직도
                </div>
                <div className="select_row" onClick={() => movePage('/introduce')}>
                  소개자료
                </div>
                <div className="select_row" onClick={() => movePage('/regulations')}>
                  관리규정
                </div>
                <div className="select_row" onClick={() => movePage('/map')}>
                  오시는 길
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area map">
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>융합원소개</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/intro')}`} onClick={() => movePage('/intro')}>
                <span>인사말</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/vision')}`} onClick={() => movePage('/vision')}>
                <span>비전 및 목표</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/history')}`} onClick={() => movePage('/history')}>
                <span>연혁</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/organization')}`} onClick={() => movePage('/organization')}>
                <span>조직도</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/introduce')}`} onClick={() => movePage('/introduce')}>
                <span>소개자료</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/regulations')}`} onClick={() => movePage('/regulations')}>
                <span>관리규정</span>
                <span className="aside_arrow">&gt;</span>
              </li>

              {/* 오시는 길 + 서브메뉴 */}
              <li className={`intro_aside_item has-sub ${isActive('/map')}`}>
                {/* 상위 항목 클릭 시 그냥 /map으로 이동 */}
                <div className="aside_main" onClick={() => movePage('/map')}>
                  <span>오시는 길</span>
                  <span className="aside_arrow">&gt;</span>
                </div>

                {/* 하위 센터 목록 (같은 페이지 내 섹션 이동) */}
                <ul className="intro_aside_sub_list">
                  <li
                    className={`sub_item ${activeCenter === 'dangjin' ? 'active' : ''}`}
                    onClick={() => scrollToSection('dangjin')}
                  >
                    <span>당진 본원</span>
                  </li>
                  <li
                    className={`sub_item ${activeCenter === 'asan' ? 'active' : ''}`}
                    onClick={() => scrollToSection('asan')}
                  >
                    <span>아산센터</span>
                  </li>
                  <li
                    className={`sub_item ${activeCenter === 'hong' ? 'active' : ''}`}
                    onClick={() => scrollToSection('hong')}
                  >
                    <span>홍성센터</span>
                  </li>
                </ul>
              </li>
            </ul>
          </aside>

          <div className="sub_main_back map">
            <div className="vision_container">
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">찾아오시는 길</div>
              </div>
            </div>

            {/* 당진 본원 */}
            <div className="map_container" ref={dangjinRef}>
              <div className="vision_container">
                <div className="vision_title_box">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">당진 본원</div>
                </div>
              </div>
              <div className="map_box">
                <KakaoMap />
              </div>
              <div className="map_info_box">
                <div className="map_info_title">주소 및 연락처</div>
                <div className="map_info_content">
                  <dl>
                    <dt>주소</dt>
                    <dd>충남 당진시 석문면 산단7로 201, 충남산학융합원 302호</dd>
                  </dl>
                  <dl>
                    <dt>TEL</dt>
                    <dd>041-354-8558</dd>
                  </dl>
                  <dl>
                    <dt>FAX</dt>
                    <dd>041-354-8559</dd>
                  </dl>
                  <dl>
                    <dt>E-MAIL</dt>
                    <dd>master@ciuc.or.kr</dd>
                  </dl>
                </div>
              </div>
              <div className="traffic_box">
                <div className="traffic_title">교통 정보</div>
                <div className="traffic_content">
                  <dl>
                    <dt>대중교통 이용 안내</dt>
                    <dd>
                      <span>
                        <strong>시내버스 이용 안내</strong>
                        당진버스터미널 승차 → 호서대 하차 140, 142번
                      </span>
                      <span>
                        <strong>시외버스 이용 안내</strong>
                        당진버스터미널 하차
                      </span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>자가용 이용 안내</dt>
                    <dd>
                      <span>
                        <strong>{'<면천IC>'}</strong>
                        면천IC교차로에서 ‘당진’ 방면으로 좌회전 → 당진1교교차로에서 ‘석문, 당진IC’ 방면으로 직진 → 통정2
                        교차로에서 ‘아산, 송악IC’ 방면으로 좌회전 → ‘산학융합지구’ 방면으로 좌회전
                      </span>
                      <span>
                        <strong>{'<송악IC>'}</strong>
                        송악IC에서 ‘고대·부곡, 산업단지’ 방면 → 현대제철교차로에서 ‘대산, 석문‘방면으로 지하차도 진입 →
                        동 곡교차로에서 ’대산, 석문‘ 방면으로 왼쪽 지하차도 진입 → 가곡교차로에서 ‘대산, 석문’ 방면으로
                        왼쪽 지하차도 진입 → 통정1로 교차로에서 ‘석문방조제, 석문국가산업단지’ 방면으로 오른쪽 방향 →
                        통정1 교차로에서 ‘산단3로’ 방면으로 우회전 → ‘산학융합지구’ 방면으로 좌회전
                      </span>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>

            {/* 아산센터 */}
            <div className="map_container" ref={asanRef}>
              <div className="vision_container">
                <div className="vision_title_box">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">아산센터</div>
                </div>
              </div>
              <div className="map_box">
                <KakaoMap2 />
              </div>
              <div className="map_info_box">
                <div className="map_info_title">주소 및 연락처</div>
                <div className="map_info_content">
                  <dl>
                    <dt>주소</dt>
                    <dd>충남 아산시 배방읍 광장로 210 와이몰 C-104~106, C-217</dd>
                  </dl>
                  <dl>
                    <dt>TEL</dt>
                    <dd>041-522-0420</dd>
                  </dl>
                  <dl>
                    <dt>FAX</dt>
                    <dd>041-354-8559</dd>
                  </dl>
                  <dl>
                    <dt>E-MAIL</dt>
                    <dd>joye@ciuc.or.kr</dd>
                  </dl>
                </div>
              </div>
              <div className="traffic_box">
                <div className="traffic_title">교통 정보</div>
                <div className="traffic_content">
                  <dl>
                    <dt>대중교통 이용 안내</dt>
                    <dd>
                      <span>
                        <strong>KTX 및 광역전철</strong>
                        아산역 2번 출구에서 620m
                        <br />
                        천안아산KTX역에서 200m
                      </span>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>

            {/* 홍성센터 */}
            <div className="map_container" ref={hongRef}>
              <div className="vision_container">
                <div className="vision_title_box">
                  <div className="logo_box">
                    <div className="logo_img"></div>
                  </div>
                  <div className="title_text">홍성센터</div>
                </div>
              </div>
              <div className="map_box">
                <KakaoMap3 />
              </div>
              <div className="map_info_box">
                <div className="map_info_title">주소 및 연락처</div>
                <div className="map_info_content">
                  <dl>
                    <dt>주소</dt>
                    <dd>충남 홍성군 홍성읍 대학길 25 혜전대학교 대학본부 203호</dd>
                  </dl>
                  <dl>
                    <dt>TEL</dt>
                    <dd>041-641-7994</dd>
                  </dl>
                  <dl>
                    <dt>FAX</dt>
                    <dd>041-354-8559</dd>
                  </dl>
                  <dl>
                    <dt>E-MAIL</dt>
                    <dd>choisy@ciuc.or.kr</dd>
                  </dl>
                </div>
              </div>
              <div className="traffic_box">
                <div className="traffic_title">교통 정보</div>
                <div className="traffic_content">
                  <dl>
                    <dt>대중교통 이용 안내</dt>
                    <dd>
                      <span>홍성역 승차 → 혜전대입구 하차 101번, 121번</span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>시내버스 이용 안내</dt>
                    <dd>
                      <span>홍성종합터미널 승차 → 혜전대입구 100번</span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>시외버스 이용 안내</dt>
                    <dd>
                      <span>홍성종합터미널 하차</span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>철도 이용 안내</dt>
                    <dd>
                      <span>홍성역 하차</span>
                    </dd>
                  </dl>
                  <dl>
                    <dt>자가용 이용 안내</dt>
                    <dd>
                      <strong>
                        {'<'}홍성IC{'>'}
                      </strong>
                      <span>
                        갈산교차로에서 ‘홍성’방면으로 우회전 → 옥암교차로에서 ‘충남도청, 홍성(군청)’방면으로 오른쪽 방향
                        → 옥암2교차로에서 ‘보령, 광천’방면으로 회전교차로에서 2시방향 → 옥암3교차로에서 ‘장곡,
                        홍동’방면으로 회전교차로에서 11시 방향 → 우회전 → 회전교차로에서 2시방향
                      </span>
                      <br />
                      <strong>
                        {'<'}해미IC{'>'}
                      </strong>
                      <span>
                        해미IC에서 ‘목포, 홍성’ 방면으로 오른쪽 방향 → 홍성IC에서 ‘안면도, 홍성’방면으로 오른쪽 고속도로
                        출구 → 홍성톨게이트 → 갈산교차로에서 ‘홍성’방면으로 우회전 → 학계교차로에서 ‘학계리,
                        남장리’방면으로 오른쪽 방향 → 학계교차로에서 ‘남장리’방면으로 좌회전 → ‘혜전대’ 방면으로 우회전
                      </span>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map;
